import type { TRemotePicture } from '~/types/media.types'

export enum THomeSectionType {
  Collection,
  Slider,
  Animation,
  DiamondHistory,
  CustomSlider,
}

export type THomeSection = (
  | THomeSectionCollection
  | THomeSectionSlider
  | THomeSectionAnimation
  | THomeSectionDiamondHistory
  | THomeSectionCustomSlider
) & {
  type: THomeSectionType
}

export type THomeSectionCollection = {
  items: {
    link: string
    name: string
    picture: TRemotePicture
  }[]
  link: string
  name: string
  picture: TRemotePicture
  pictureSquare: boolean
  poster: {
    desktop: string
    mobile: string
  }
  video: TNullable<{
    desktop: string
    mobile: string
  }>
}

export type THomeSectionSlider = {
  isDark: boolean
  isLight: boolean
  navigation: {
    buttonLink: string
    buttonText: string
    subtitle: string
    title: string
  }
  sliderType: 'brilliants' | 'constructor'
  slides: {
    icon?: string
    link: string
    name: string
    picture: TRemotePicture
    poster: {
      desktop: string
      mobile: string
    }
    video: TNullable<{
      desktop: string
      mobile: string
    }>
  }[]
  title?: string
}

export type THomeSectionAnimation = {
  isSquad: boolean
  navigation: {
    buttonLink: string
    buttonText: string
    description: string
    icon: string
    title: string
  }
  picture: TRemotePicture
  title: string
}

export type THomeSectionDiamondHistory = {
  navigation: {
    buttonLink: string
    buttonText: string
    icon: string
    title: string
  }
  picture: TRemotePicture
}

export interface ICustomSliderBox extends THomeSectionCollection {
  title: string
}

export type THomeSectionCustomSlider = {
  autoplay: number
  boxes: TNullable<ICustomSliderBox>[]
  buttonText: string
  link: string
  slides: {
    buttonText: string
    isDark: boolean
    isLight: boolean
    isSquad: boolean
    link: string
    name: string
    picture: TRemotePicture
    poster: {
      desktop: string
      mobile: string
    }
    video: TNullable<{
      desktop: string
      mobile: string
      runTime?: string
      textBottom?: string
    }>
  }[]
  title: string
}
